import { PointsBasedTagsDetailView } from "@features/dashboard/components/Progress/PointsBasedTagsDetailView";
import { useReport } from "@features/report/hooks/useReport";
import { useAppStore } from "@hooks/useAppStore";
import TopicsDetailView from "components/Topics/TopicsDetailView";
import { useLocalSearchParams } from "expo-router";

const DetailedListMasteryContainer = () => {
	const { type } = useLocalSearchParams<{
		type: string;
	}>();
	const { reportDetails } = useReport();

	const showPointsBasedScore = useAppStore(
		(state) => state.reportView?.formative?.showPointsBasedScore,
	);

	if (!reportDetails) {
		return null;
	}

	const { tagDetails } = reportDetails;

	if (showPointsBasedScore) {
		return <PointsBasedTagsDetailView title={type!} tags={tagDetails} />;
	}

	return <TopicsDetailView tags={tagDetails} fromReport type={type} />;
};

export default DetailedListMasteryContainer;
